<template>
  <div id="app">
    <Header @changeLang="changeLang" />
    <div class="app-content">
      <div class="app-article">
        <router-view/>
        <Footer />
      </div>
    </div>
  </div>
</template>
<script>
import Header from '@/components/Header.vue'
import Footer from '@/components/Footer.vue'
import axios from 'axios'
export default {
  components: {Header, Footer},
  data(){
    return {
      lang: 'cn'
    }
  },
  watch: {
    '$route': function(to,from){
      // 页面跳转时，滚动条置0
      document.querySelector(".app-content").scrollTop = 0
    }
  },
  methods: {
    changeLang(obj){
      document.title=this.$i18n.messages[obj].meta.title;
      // console.log(this.$i18n.messages[obj]);
      // document.title=$t('new2');
      this.$i18n.locale = obj
      localStorage.setItem("lang", obj)
    }
  },
  created(){
    let _this = this
    axios.interceptors.response.use(res => {
      if(res.data.status !== 1){
        _this.$message({message: res.data.descript, type: "error"})
        if(res.data.status === 400151){
          this.$router.push({path: '/user/changepsw'})
        }
      }
      return res
    }, err => {
      _this.$message({message: err, type: "error"})
      return Promise.reject(err)
    })
  }
}
</script>
<style lang="scss">
#app{display: flex; flex-direction: column; min-height: 100%;word-break: keep-all;}
.app-content{flex: 1; overflow: auto;}
.app-article{min-height: 100%; position: relative; padding-bottom: 775px; overflow: hidden;}

// reset css
*{margin: 0; padding: 0; font-family: "Microsoft Yahei";}
*,*:before,*:after{box-sizing: border-box;}
ul,ol{list-style: none;}
a{text-decoration: none; cursor: pointer;}
html,body{height: 100%; }
body{min-width: 1440px; background: #fbfbfb; font-size: 14px;}
input,textarea{outline: none;}

// common css
.article{width: 1200px; margin: 0 auto;}
.article:after{content: ''; display: block; clear: both;}
.ui-box{width: 1200px; margin: 0 auto; border: 1px solid #eee; box-shadow: 0 12px 12px rgba($color: #000, $alpha: .03); background: #fff; border-radius: 12px;}
.ui-wrap{padding: 80px 0 78px;}
.ui-pannel{
  .title{padding: 31px 50px 30px; line-height: 26px; font-size: 20px; font-weight: bold; color: #333; border-bottom: 1px solid #eee;}
  background: #fff; border-radius: 6px;
  &+.ui-pannel{margin-top: 20px;}
}
.ui-btn{
  display: inline-block; height: 42px; line-height: 42px; text-align: center; padding: 0 22px; border-radius: 42px; color: #fff; background: #002147; min-width: 140px; transition: background .3s;
  &:hover{background: lighten(#002147, 5%);}
  &:active{background: darken(#002147, 5%);}
  &.gray{
    background: #8A8A8A;
    &:hover{background: lighten(#8A8A8A, 5%);}
    &:active{background: darken(#8A8A8A, 5%);}
  }
  &.blue{
    background: #4E9CDA;
    &:hover{background: darken(#4E9CDA, 5%);}
    &:active{background: darken(#4E9CDA, 10%);}
  }
  &.ligh{
    background: #A9C4B1;
    &:hover{background: darken(#A9C4B1, 5%);}
    &:active{background: darken(#A9C4B1, 10%);}
  }
}
.ui-radio{
  position: relative; display: inline-block; padding: 0 20px 0 42px; line-height: 42px; cursor: pointer;
  &:before{content: ''; position: absolute; top: 14px; left: 14px; width: 14px; height: 14px; border: 4px solid #999; border-radius: 50%;}
  &.checked{
    &::before{border: 1px solid #000;}
    &:after{content: ''; position: absolute; top: 17px; left: 17px; width: 8px; height: 8px; border-radius: 50%; background: #000;}
  }
}
.ui-checkbox{
  display: inline-block; position: relative; padding: 0 20px 0 42px; line-height: 42px; cursor: pointer; min-height: 42px;
  &:before{content: ''; position: absolute; top: 14px; left: 14px; width: 14px; height: 14px; border: 3px solid #999; border-radius: 3px;}
  &.checked{
    &:before{border: 0; background: url(./assets/checkbox.png);}
  }
}
.ui-avatar{ width: 100%; height: 100%; vertical-align: top; object-fit: cover;}
.ui-pop{position: fixed; top: 0; left: 0; right: 0; bottom: 0; z-index: 99999999; display: flex; align-items: center; justify-content: center;}
.ui-mask{height: 100%; background: rgba($color: #000, $alpha: .7); position: absolute; left: 0; width: 100%; top: 0;}
.ui-modal{
   width: 600px; background: #fff; border-radius: 12px; box-shadow: 0 6px 12px rgba($color: #000, $alpha: .05); max-height: 90%; position: relative; z-index: 1; overflow: hidden; display: flex; flex-direction: column;
  .modal-title{line-height: 140px; border-bottom: 1px solid #e5e5e5; text-align: center; font-size: 32px;}
  .modal-close{position: absolute; top: 47px; right: 57px; width: 50px; height: 50px; line-height: 50px; text-align: center;line-height: 50px; font-size: 32px; i{font-weight: bold;} &:hover{opacity: .7;}}
  &.large{width: 1000px;}
  &.scroll{
    .content{flex: 1; overflow: auto; }
  }
  .btns{
    text-align: center; 
    .ui-btn{margin: 0 25px;}
  }
}
.ui-comfirm{
  width: 520px; min-height: 375px; text-align: center;
  .title{padding: 34px 50px 30px; line-height: 32px; border-bottom: 1px solid #d6d6d6; font-size: 32px; text-align: center;} 
  .btns{margin-top: 40px;}
  .content{padding-top: 35px;}
  .topic{font-size: 18px; line-height: 1; margin-bottom: 18px;}
  .desc{color: #666;}
}
.ui-empty{padding: 370px 100px 200px; background: url(./assets/empty.png) no-repeat center 200px; font-size: 16px; color: #c2c2c2; text-align: center;}
.ui-error{font-size: 12px; color: red; line-height: 1; margin: 2px 0 -14px; padding: 0 22px;}
.voidrate{width: 24px; height: 24px; background: url(./assets/rate.png); margin-right: 10px;}
.rated{width: 24px; height: 24px; background: url(./assets/rate2.png); margin-right: 10px;}

// elementui reset
.el-select.ui-select{
  .el-input__inner{
    height: 42px; border-radius: 42px; line-height: 42px; padding: 0 65px 0 24px; position: relative; background: #ededed;
  }
  .el-input__suffix{width: 22px; height: 12px; top: 15px; right: 23px; background: url(./assets/arrow_down.png);}
  .el-input__suffix-inner{display: none;}
}
.el-date-editor.ui-datepicker{
  .el-input__inner{
    height: 42px; border-radius: 42px; line-height: 42px; padding: 0 65px 0 24px; position: relative; background: #ededed;
  }
  .el-input__prefix{display: none;}
}
.el-select-dropdown.el-popper[x-placement^=bottom]{
  margin-top: 3px; border-radius: 21px; overflow: hidden;
  .popper__arrow{display: none;}
}
.el-select-dropdown.el-popper[x-placement^=top]{
  margin-bottom: 3px; border-radius: 21px; overflow: hidden;
  .popper__arrow{display: none;}
} 
.el-select-dropdown .el-select-dropdown__list{padding: 10px 0; background: #ededed; }
.select-item{
  .el-select.ui-select .el-input__inner{border: 0; height: auto; line-height: 40px;}
}
.el-upload-list--picture-card.el-upload-list .el-upload-list__item{
  width: 194px; height: 194px; border: 1px solid #707070; margin: 10px 20px 10px 0; border-radius: 0;
  .el-upload-list__item-status-label{display: none;}
  .el-upload-list__item-actions{background: transparent;}
  .el-upload-list__item-delete{position: absolute; bottom: 0; left: 0; right: 0; top: auto; height: 46px; background:  rgba($color: #000, $alpha: .74) url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAMAAAC6V+0/AAAAY1BMVEUAAAD/AAD/AAD/AAD/AAD/AAD/AAD/AAD/AAD/AAD/AAD/AAD/AAD/AAD/AAD/AAD/AAD/AAD/AAD/AAD/AAD/AAD/AAD/AAD/AAD/AAD/AAD/AAD/AAD/AAD/AAD/AAD/AACP4fsiAAAAIHRSTlMA0swdDuEzLfD6UuDz7Ny+uJRJQx8WBsuonpt2aSQRCiGgN0YAAABySURBVBjTzc1JEoIwFEXRSxISYmgVsNe//1VqyRe1cAGcqje5k8fseGbBSvoXc2admWQSjbqQZOGA836z021fCyNwiw02tlDVjKV5X2SE55ACJ/mqo40NFOk3Ega49p84SOVQXmome/nSaezbKKo83YEHYcMOTmbm4GoAAAAASUVORK5CYII=) no-repeat center center;}
  .el-icon-delete{display: none;}
}
.el-upload.el-upload--picture-card,.img-list .el-upload.el-upload--text{
  width: 194px; height: 194px; border-radius: 0; border: 1px solid #707070; margin: 10px 0; background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC0AAAAtCAMAAAANxBKoAAAAPFBMVEUAAADe3t7c3Nzd3d3h4eHi4uLg4ODd3d3c3Nzd3d3d3d3c3Nzd3d3c3Ny/v7/d3d3d3d3e3t7Y2Njd3d1fW4w2AAAAE3RSTlMAHysPBxsW+vPryb+vOQTBpUUN4Ed7CgAAAHFJREFUSMft1TkOwCAMRNGBmC174vvfNUAJFKaJoohfjl7nwmhlZl4shBHHPAm14ZQRap21GnroH+h9Ktuy1tW+A9aztHDjYHkruKOAuUMv0E6MvQJIlV2c2qqdPnXLoYd+Q9uuf0ku4kAQZlZ3WjR6AHmCH+mhU9cgAAAAAElFTkSuQmCC) no-repeat center center;
}
.uploadStudentId{
  .el-upload-list{display: inline-block; height: 42px; line-height: 42px; vertical-align: top;}
}
.ui-pagination.el-pagination{
  text-align: center; margin: 50px 0 40px; font-weight: normal;
  &.is-background .el-pager li{
    background: #fdfdfd; color: #adadad;
    &:not(.disabled).active{
      background: #002147; border: 0;
    }
  }
  .el-pager li{border: 1px solid #ececec;}
}
.preCode.el-select{
  width: 70px;
  .el-input__inner{border: 0; background: #ededed; border-radius: 25px 0 0 25px; padding: 0 15px 0 0; text-align: center;}
}
@media screen and (max-width: 768px) {
  *{font-family: PingFang SC;}
  body{
    min-width:auto;
    width: 100%;
    overflow-x: hidden;
  }
  .article{
    width: 100%;
  }
  .app-article{
    word-break: normal;
    padding-bottom: 0;
  }
  .ui-pagination.el-pagination{
    margin: 20px 0;
  }
  .ui-modal .modal-title{
    line-height: normal;
    padding: 20px 0;
    font-size: 16px;
  }
  .ui-modal .modal-close{
    font-size: 25px;
    top: 6px;
    right: 0;
  }
  .app-content{
    overflow-x: hidden!important;
  }
}
</style>
